import EndpointsBase  from "../EndpointsBase";
import { RXCONTROLLER_API_PATH } from "../../utils/Constants";
import { IBoxCancellationRequest, IOrderInfoRequest, IPurgeRequest, IRXOperatorInfoModel, ISnoozeRequest } from "../rxAutoMessages/rxAutoMessages";
import { throws } from "assert";

class RXWestEndpoints extends EndpointsBase { 
    constructor(baseUrl: string | undefined = RXCONTROLLER_API_PATH) {
        super(RXCONTROLLER_API_PATH);
    }

    sendScannedIPackBoxBarcode = (req: IOrderInfoRequest) => {
        return this._sendRequest({
            method: "box",
            headers: this._getAuthHeader(),
            data: req ,
            run: this.server.postData
        });
    }

    sendFlushQueueRequest = (req: IPurgeRequest) => {
        return this._sendRequest({
            method: "workstation/flush_queue",
            headers: this._getAuthHeader(),
            data: req,
            run: this.server.postData
        });
    }

    sendLoginInfo = (req: IRXOperatorInfoModel) => {
        return this._sendRequest({
            method: "workstation/login",
            headers: this._getAuthHeader(),
            data: req,
            run: this.server.postData
        })
    }

    sendSortBoxSnooze = (req: ISnoozeRequest) => {
        return this._sendRequest({
            method: "order/snooze",
            headers: this._getAuthHeader(),
            data: req,
            run: this.server.postData
        })
    }

    sendBoxCancellation = (req: IBoxCancellationRequest) => {
        return this._sendRequest({
            method: "box/cancelbox",
            headers: this._getAuthHeader(),
            data: req,
            run: this.server.postData
        })
    }

    sendMaxxOrderFinished = (rxSortBoxId: number, workstationId: number) => {
        return this._sendRequest({
            method: "order/finish_rx_bag",
            headers: this._getAuthHeader(),
            data: { rxSortBoxId, workstationId },
            run: this.server.postData
        });
    }

    getTeamleaderAvailability = (workstationID: number) => {
        return this._sendRequest({
            method: "workstation/teamleader_available",
            headers: this._getAuthHeader(),
            data: { workstationID },
            run: this.server.getData
        });
    }

    setWarehouseAlarm = (workstationID: number) => {
        return this._sendRequest({
            method: "workstation/alarm",
            headers: this._getAuthHeader(),
            data: {
                WorkstationID: workstationID
            },
            run: this.server.postData
        });
    }

    handleRxOrderFinished(
        sortBoxId: number,
        workstationId: number,
      ) {
        return this._sendRequest({
          method: `order/order_close`,
          headers: this._getAuthHeader(),
          data: {
            SortBoxID:sortBoxId,
            WorkstationID:workstationId,
          },
          run: this.server.postData,
        });
      }
}

export default new RXWestEndpoints();